import { render } from "./ItemModal.vue?vue&type=template&id=0b3f313d&scoped=true"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"

import "./ItemModal.vue?vue&type=style&index=0&id=0b3f313d&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3f313d"]])

export default __exports__